export default {
  state: {
    visibility: false,
    filter: null,
    category_items: []
  },
  mutations: {
    INIT_FILTER_DIALOG(state, payload) {
      state.visibility = true
      state.filter = payload
    },
    RESET_DELETE_ITEM_DIALOG(state) {
      state.visibility = false
      state.filter = null
    },
    SET_FILTER_DIALOG_CATEGORY_ITEMS(state, payload) {
      state.category_items = payload
    }
  },
  actions: {}
}
